// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电工学",
      "tec": "荆澜涛王亮",
      "week": "1-16周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "数据结构与算法",
      "tec": "施昭",
      "week": "1-16周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "模拟电子技术",
      "tec": "于源",
      "week": "9-16周",
      "add": "215国教"
    },
    [
      {
        "sub": "Python程序设计",
        "tec": "张悦",
        "week": "1,3,5,7,9,11,13,15周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "概率论与数理统计",
        "tec": "张敏夫",
        "week": "1-17双周",
        "add": "教学楼C座210教务"
      }
    ],
    0
  ],
  "2": [
    {
      "sub": "大学物理（下)",
      "tec": "江翠",
      "week": "1-14周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "马睿",
      "week": "1-8,11-14周",
      "add": "教学楼A座421机械"
    },
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25自机2-1",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "25自机2-3",
        "tec": "丁璐瑶",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25自机2-4",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25自机2-2",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25自机1-1",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "25自机1-3",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25自机1-4",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "25自机1-2",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "教学楼B座220能动"
      }
    ],
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "1-4周",
      "add": "教学楼C座111教务"
    },
    0
  ],
  "3": [
    [
      {
        "sub": "Python程序设计",
        "tec": "张悦",
        "week": "1,3,5,7,9,11,13,15周",
        "add": "教学楼B座221自控"
      },
      {
        "sub": "Python程序设计",
        "tec": "张悦",
        "week": "2,4,6,8,10,12,14,16周",
        "add": "教学楼B座221自控"
      }
    ],
    [
      {
        "sub": "就业创业指导",
        "tec": "杨乘一",
        "week": "1-5周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "模拟电子技术",
        "tec": "于源",
        "week": "9-16周",
        "add": "215国教"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "马克思主义基本原理",
      "tec": "马睿",
      "week": "1-8,11-14周",
      "add": "教学楼A座325电力"
    },
    {
      "sub": "大学物理（下)",
      "tec": "江翠",
      "week": "1-14周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "商晶",
      "week": "1-16周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "张敏夫",
      "week": "1-11,13-17周",
      "add": "教学楼C座212教务"
    },
    0
  ],
  "5": [
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25自机2-3",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "25自机2-1",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25自机2-2",
        "tec": "丁璐瑶",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25自机2-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25自机1-5",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25自机1-2",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "25自机1-4",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25自机1-3",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "教学楼B座119自控"
      }
    ],
    [
      {
        "sub": "体育（三）",
        "tec": "郝策",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男网",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "足球",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男羽",
        "tec": "李莉",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "女篮",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男篮",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男网",
        "tec": "李灏",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男乒",
        "tec": "张慧",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "健美操",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "搏击"
      }
    ],
    {
      "sub": "数据结构与算法",
      "tec": "施昭",
      "week": "1-16周",
      "add": "教学楼B座119自控"
    },
    {
      "sub": "创造性思维与创新方法",
      "tec": "施昭",
      "week": "1-8周",
      "add": "实训楼F座103自控"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
